export class ElectronicDocumentResponse {
    electronicDocumentsMark: boolean;
    email:  string;
    accountNumber: string;
}
